import {
	listReports, reviewReport,
	listReportCategories, createReportCategory, updateReportCategory, deleteReportCategory,
} from '@/services/agency/reports.service'

export default {
	namespaced: true,
	state: {
		list:           { data: [], meta: { pagination: { total: 0, count: 0, per_page: 20, current_page: 1, total_pages: 1 } } },
		listStatus:     'init',
		// The last query the queue was loaded with, so a review reloads the same page and filters instead of the first page of everything.
		listParams:     {},
		categories:     [],
		// Which platform answered and which languages to offer (`meta` of the category list).
		categoriesMeta: { system: null, locales: ['en', 'pt-BR', 'es', 'de', 'ro'] },
		catStatus:      'init',
	},
	getters: {
		getList:       (s) => s.list,
		getListStatus: (s) => s.listStatus,
		getCategories: (s) => s.categories,
		getCategoriesMeta: (s) => s.categoriesMeta,
		getCatStatus:  (s) => s.catStatus,
	},
	mutations: {
		SET_LIST(state, v)       { state.list = v },
		SET_LIST_STATUS(state, v){ state.listStatus = v },
		SET_LIST_PARAMS(state, v){ state.listParams = v },
		SET_CATEGORIES(state, v) { state.categories = v },
		SET_CATEGORIES_META(state, v) { state.categoriesMeta = v },
		SET_CAT_STATUS(state, v) { state.catStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_PARAMS', params || {})
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listReports(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async review({ dispatch, state }, data) {
			await reviewReport(data)
			dispatch('fetchList', state.listParams)
		},
		async fetchCategories({ commit }) {
			commit('SET_CAT_STATUS', 'pending')
			try {
				// Only this platform's own categories and the universal ones: the others belong to other admins.
				const { data } = await listReportCategories({ scope: 'platform' })
				commit('SET_CATEGORIES', data.data || [])
				if (data.meta) commit('SET_CATEGORIES_META', data.meta)
				commit('SET_CAT_STATUS', 'init')
			} catch {
				commit('SET_CAT_STATUS', 'error')
			}
		},
		async createCategory({ dispatch }, data) {
			const { data: saved } = await createReportCategory(data)
			dispatch('fetchCategories')

			return saved.data
		},
		async updateCategory({ dispatch }, data) {
			const { data: saved } = await updateReportCategory(data)
			dispatch('fetchCategories')

			return saved.data
		},
		async removeCategory({ dispatch }, id) {
			await deleteReportCategory(id)
			dispatch('fetchCategories')
		},
	},
}
